import createLucideIcon from '../createLucideIcon';
import { IconNode } from '../types';

export const __iconNode: IconNode = [
  ['path', { d: 'm2 21 9.6-9.6', key: '9l79m3' }],
  ['path', { d: 'm7.5 15.5 2.3 2.3a1 1 0 0 1 0 1.4l-2.1 2.1a1 1 0 0 1-1.4 0L4 19', key: 'fw8biw' }],
  ['circle', { cx: '15.5', cy: '7.5', r: '5.5', key: '4wxmhb' }],
];

/**
 * @component @name Key
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtMiAyMSA5LjYtOS42IiAvPgogIDxwYXRoIGQ9Im03LjUgMTUuNSAyLjMgMi4zYTEgMSAwIDAgMSAwIDEuNGwtMi4xIDIuMWExIDEgMCAwIDEtMS40IDBMNCAxOSIgLz4KICA8Y2lyY2xlIGN4PSIxNS41IiBjeT0iNy41IiByPSI1LjUiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/key
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Key = createLucideIcon('key', __iconNode);

export default Key;
